import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './CommentDeleteNotification';
import { unhideComment } from '../Comment/redux/actionCreators';
import { CommentStoreState } from '../Comment/redux/types';
import { isCommentReduxReady } from '../Comment/redux/selectors';

type StateProps = Pick<Props, 'isCommentReduxReady'>;
type DispatchProps = Pick<Props, 'onUnhide'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, CommentStoreState> = state => ({
  isCommentReduxReady: isCommentReduxReady(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onUnhide: unhideComment,
};

export default connect(mapStateToProps, mapDispatchToProps);
